import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const BottomSheetSlideHTML: FC = () => {
  let templateWidth = useSelector(
    (state: RootState) => state.template.templateWidth
  );
  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let currentUser = useSelector((state: RootState) => state.client.userCompany);
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);
  let deeplink = useSelector((state: RootState) => state.imageUpload.deeplink);

  let text = useSelector((state: RootState) => state.editText.text);
  let fontSize = useSelector((state: RootState) => state.editText.fontSize);
  let fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  let color = useSelector((state: RootState) => state.editText.color);
  let fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  let textAlign = useSelector((state: RootState) => state.editText.textAlign);

  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  let btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  let btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  let btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  let tracking = useSelector((state: RootState) => state.trackings.tracking);
  let button1 = useSelector((state: RootState) => state.trackings.button1);
  let button2 = useSelector((state: RootState) => state.trackings.button2);

  const multiTitleURL = getFontURL(fontFamily?.multi_title);
  const multiSubTitleURL = getFontURL(fontFamily?.multi_sub_title);
  const multiLeftButtonURL = getFontURL(btnFontFamily?.multi_left_button);
  const multiRightButtonURL = getFontURL(btnFontFamily?.multi_right_button);
  // const multiTitleURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily.multi_title}`;
  // const multiSubTitleURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily.multi_sub_title}`;
  // const multiLeftButtonURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_left_button}`;
  // const multiRightButtonURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_right_button}`;

  const style = `
  @font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleURL});
    }

  @font-face {
    font-family: 'multiSubTitle';
    src: url(${multiSubTitleURL});
    }
  
  @font-face {
    font-family: 'multiLeftButton';
    src: url(${multiLeftButtonURL});
    }


  @font-face {
    font-family: 'multiRightButton';
    src: url(${multiRightButtonURL});
    }
    
    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;
      
      position: relative;
      background: none;
      overflow: hidden;
    }
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .modal_wrapper {
      width: 100%;
      height: 20.5rem;

      position: absolute;
      bottom: 0;

      overflow: hidden;
      border-radius: ${radius?.multi_image}px ${radius?.multi_image}px 0 0;
      background-color: transparent;
      z-index: 0;
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list,
    .slick_wrapper .slick-track div,
    .slick_wrapper .slick-track img {
      width: 100%;
      height: 16rem;
      outline: none;
    }
    .slick-track {
      display: flex;
    }
    .slick-track img {
      object-fit: cover;
    }
    .slick_page {
      padding: 0.25rem 1rem;
      position: absolute;
      top: 1rem;
      right: 1rem;

      display: flex;
      gap: 0.25rem;

      color: #fff;
      font-family: Roboto;
      font-size: 0.875rem;
      font-weight: 500;

      border-radius: 999px;
      background-color: rgba(0, 0, 0, 0.8);
      z-index: 1;
    }

    .contents_wrapper {
      width: 100%;
      margin-top: 1.5rem;
      padding: 0 10%;

      position: absolute;
      top: 0;
      z-index: 1;
    }
    .contents_box .title {
      width: 100%;
      height: 3rem;
      margin-bottom: 0.5rem;

      display: flex;
      align-items: center;
    }
    .contents_box .title .title_inner {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: ${textAlign?.multi_title};
      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily?.multi_title
          : 'multiTitle'
      };
    }
    .contents_box .sub_title {
      width: 100%;
      height: 1.875rem;

      display: flex;
      align-items: center;
    }
    .contents_box .sub_title_inner {
      max-height: 1.875rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.multi_sub_title};
      color: ${color?.multi_sub_title};
      font-size: ${fontSize?.multi_sub_title}rem;
      font-weight: ${fontWeight?.multi_sub_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
          fontFamily?.multi_sub_title
        )
          ? fontFamily?.multi_sub_title
          : 'multiSubTitle'
      };
    }

    .slick-slider {
      position: relative;
    }
    .slick-dots {
      position: absolute;
      bottom: 1rem;
    }
    .slick-dots li {
      width: 4px;
      height: 4px;
      margin: 0 0.5rem;
    }
    .slick-dots li button {
      width: 4px;
      height: 4px;
      padding: 0;
      border-radius: 4px;
      background: black;
      opacity: 0.3;
    }
    .slick-dots .slick-active button {
      opacity: 1;
    }
    .slick-dots li button::before {
      width: 4px;
      height: 4px;
      padding: 0;
      display: none;
    }

    .btn_wrapper {
      width: 100%;
      height: 4.5rem;
      padding: 1rem 10%;
      padding-bottom: 1.5rem;

      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
      background-color: #fff;
    }
    .btn_wrapper button {
      border: 0;
    }
    .btn_wrapper .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      text-align: left;
      font-size: ${btnFontSize?.muli_left_button}rem;
      font-weight: ${btnFontWeight?.multi_left_button};
      color: ${btnColor?.multi_left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
          btnFontFamily?.multi_left_button
        )
          ? btnFontFamily?.multi_left_button
          : 'multiLeftButton'
      };
      background-color:rgba(${btnBgColorR?.multi_left_button},${
    btnBgColorG?.multi_left_button
  }, ${btnBgColorB?.multi_left_button}, ${btnBgColorA?.multi_left_button});
    }
    .btn_wrapper .style02 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: right;
      font-size: ${btnFontSize?.multi_right_button}rem;
      font-weight: ${btnFontWeight?.multi_right_button};
      color: ${btnColor?.multi_right_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins'].includes(
          btnFontFamily?.multi_right_button
        )
          ? btnFontFamily?.multi_right_button
          : 'multiRightButton'
      };
      background-color:rgba(${btnBgColorR?.multi_right_button},${
    btnBgColorG?.multi_right_button
  }, ${btnBgColorB?.multi_right_button}, ${btnBgColorA?.multi_right_button});
    }

    .bottom_wrapper {
      position: absolute;
      left: 10%;
      bottom: 6.75rem;
    }
    .bottom_wrapper button {
      width: 5.5rem;
      height: 2rem;

      display: flex;
      justify-content: center;
      align-items: center;

      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.multi_button}rem;
      font-weight: ${btnFontWeight?.multi_button};
      color: ${btnColor?.multi_button};
      font-family: ${btnFontFamily?.multi_button};

      border: 0;
      border-radius: ${radius?.multi_button}px;
      background-color:rgba(${btnBgColorR?.multi_button},${
    btnBgColorG?.multi_button
  }, ${btnBgColorB?.multi_button}, ${btnBgColorA?.multi_button});
    }

    @media screen and (min-width: 608px) and (max-width: 1024px) {
      .modal_wrapper {
        height: 36.5rem;
      }
      .slick_wrapper,
      .slick_wrapper .slick-slider,
      .slick_wrapper .slick-list,
      .slick_wrapper .slick-track div,
      .slick_wrapper .slick-track img {
        height: 30rem;
      }
      .slick_page {
        top: 2.5rem;
        right: 2.5rem;
      }

      .contents_wrapper {
        margin-top: 0;
        padding: 3rem;
      }
      .contents_box .title {
        font-size: ${fontSize?.multi_title + 0.75}rem;
      }
      .contents_box .sub_title {
        height: 3rem;
        font-size: ${fontSize?.multi_sub_title + 0.5}rem;
      }
      .contents_box .sub_title_inner {
        max-height: 3rem;
      }

      .btn_wrapper {
        height: 6.5rem;
        padding: 2rem;
        padding-top: 1.5rem;
      }
      .style01 {
        font-size: ${btnFontSize?.multi_left_button + 0.5}rem;
      }
      .style02 {
        font-size: ${btnFontSize?.multi_right_button + 0.5}rem;
      }
    }
  `;

  const html =
    `
    <div class="root">
      <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="modal_wrapper">
        <div class="slick_wrapper">
          <div class="slick_slider">` +
    bgImage?.multi_image
      ?.map((data: any, idx: number) => {
        return `
        <div>
          <img
            class="image"
            src="${bgImage?.multi_image[idx]}"
            alt="half top image"
          />
        </div>
            `;
      })
      .join('') +
    `
          </div>
        </div>
        <div class="contents_wrapper">
          <div class="contents_slider">` +
    text?.multi_title
      ?.map((data: any, idx: number) => {
        return `
        <div class="contents_box">
          <div class="title"><div class="title_inner">${changeEnterHTML(
            text?.multi_title?.[idx]
          )}</div></div>
          <div class="sub_title">
            <div class="sub_title_inner">
              ${changeEnterHTML(text?.multi_sub_title?.[idx])}
            </div>
          </div>
        </div>`;
      })
      .join('') +
    `
          </div>
        </div>
        <div class="btn_wrapper">
          <button class="style01">
            ${btnText?.multi_left_button?.[currentIndex]}
          </button>
          <button class="style02">
            ${btnText?.multi_right_button?.[currentIndex]}
          </button>
        </div>
      </div>
    </div>
  `;

  let deeplink_list = `[`;
  for (let i = 0; i < deeplink?.multi_image?.length; i++) {
    deeplink_list += `'${deeplink?.multi_image?.[i]}'`;
    if (i !== deeplink?.multi_image?.length - 1) deeplink_list += ',';
  }
  deeplink_list += ']';

  let button_list = `[`;
  for (let i = 0; i < btnText?.multi_left_button?.length; i++) {
    button_list += `['${btnText?.multi_left_button?.[i]}', '${btnText?.multi_right_button?.[i]}']`;
    if (i !== btnText?.multi_left_button?.length - 1) button_list += ',';
  }
  button_list += ']';

  let tracking_list = `[`;
  for (let i = 0; i < tracking?.multi_image?.length; i++) {
    tracking_list += `['${tracking?.multi_image?.[i]}', '${tracking?.multi_left_button?.[i]}', '${tracking?.multi_right_button?.[i]}'],`;
  }
  tracking_list += ']';

  let tracking_button_list = trackingList(
    'BOTTOM SHEET SLIDE',
    button1,
    button2
  );

  const js = `
  document.addEventListener("DOMContentLoaded", function(){
    $('.slick_slider').slick({
      arrows: false,
      infinite: true,
      dots: true,
  
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 300,
      touchThreshold: 300
    });

    $('.contents_slider').slick({
      arrows: false,
      infinite: true,
      fade: true,
      swipe: false,
  
      speed: 300,
      touchThreshold: 300
    });

    let currentIndex = 0;
    let button = ${button_list};
    $('.style00').text(button[currentIndex][0]);
    $('.style01').text(button[currentIndex][1]);
    $('.style02').text(button[currentIndex][2]);
    $('.slick_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      currentIndex = $('.slick_slider').slick('slickCurrentSlide');
      $('.contents_slider').slick('goTo', currentIndex);
      $('.style01').text(button[currentIndex][0]);
      $('.style02').text(button[currentIndex][1]);
    });
    $('.contents_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      currentIndex = $('.contents_slider').slick('slickCurrentSlide');
      $('.slick_slider').slick('goTo', currentIndex);
      $('.style01').text(button[currentIndex][0]);
      $('.style02').text(button[currentIndex][1]);
    });

    let deeplink = ${deeplink_list};
    let tracking = ${tracking_list};
    let button1 = ${tracking_button_list[0]};
    let button2 = ${tracking_button_list[1]};
    $('.image').click(function() {
      appboyBridge.logClick(tracking[currentIndex][0]);
      try {
        if (button1[0].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[0].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = deeplink[currentIndex];
    });
    $('.style01').click(function() {
      appboyBridge.logClick(tracking[currentIndex][1]);
      try {
        if (button1[1].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[1].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      appboyBridge.closeMessage();
    });
    $('.style02').click(function() {
      appboyBridge.logClick(tracking[currentIndex][2]);
      try {
        if (button1[2].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('0');
        }
        if (button2[2].indexOf(currentIndex) !== -1) {
          appboyBridge.logClick('1');
        }
      } catch (err) {}
      window.location = deeplink[currentIndex];
    });
  });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          http-equiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta http-equiv="Expires" content="0" />
        <meta http-equiv="Pragma" content="no-cache" />

        {/* slick */}
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.css"
        />
        <script
          type="text/javascript"
          src="https://cdn.jsdelivr.net/npm/slick-carousel@1.8.1/slick/slick.min.js"
        ></script>

        {/* google font */}
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick-theme.css"
        />

        {/* jquery */}
        <script
          id="test"
          src="https://code.jquery.com/jquery-3.6.0.min.js"
        ></script>
        <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.js"></script>
        <style dangerouslySetInnerHTML={{ __html: style }}></style>
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }}></body>
      <script dangerouslySetInnerHTML={{ __html: js }}></script>
    </>
  );
};
export default BottomSheetSlideHTML;
